import { addZero } from "@api";

export const timeSlotGenerator = (start: Date, end: Date, slotMinute: number) => {
  const timeSlot: {
    label: string;
    value: { hours: number; minutes: number };
  }[] = [];

  const slotMilisenconds = slotMinute * 1000 * 60;

  for (let currentTime = start.getTime(); currentTime < end.getTime(); currentTime += slotMilisenconds) {
    const currentDate = new Date(currentTime);
    timeSlot.push({
      label: `${currentDate.getHours()}h${addZero(currentDate.getMinutes())}`,
      value: { hours: currentDate.getHours(), minutes: currentDate.getMinutes() },
    });
  }

  return timeSlot;
};
